export default {
  AirMaster: 'AirMaster-China',
  'dashboard.index.647741-0': '国内日出东方物联网系统',
  'dashboard.index.647741-1': 'unit',
  'dashboard.index.647741-2': '年',
  'dashboard.index.647741-3': '月',
  'dashboard.index.647741-4': '日',
  'dashboard.index.647741-5': 'Foshan',
  总设备数: 'Total device',
  在线设备数: 'Total online devices',
  离线设备数: 'Total offline devices',
  未激活设备数: 'Total inactive devices',
  'components.bottom-left.467967-0': 'Installation Record',
  IMEI号码: 'IMEI Number',
  产品类型: 'Product Type',
  安装时间: 'Installation Date',
  客户名称: 'Customer Name',
  安装人员: 'Installer',
  安装状态: 'Status',
  安装位置: 'Installation Address',
  'components.bottom-left.467967-1': 'Device Statistics',
  'components.bottom-left.467967-2': 'Installed',
  'components.bottom-left.467967-3': 'Uninstalled',
  设备总数: 'Total',
  'components.bottom-right.424290-0': 'Personnel Statistics',
  'components.bottom-right.424290-1': 'persons',
  'components.bottom-right.424290-2': 'family',
  设备用户总人数: 'Total Users',
  经销商入驻数: 'Total Distributor',
  安装工入驻数: 'Total Installer',
  售后工程师: 'Total Engineer',
  'components.bottom-right.424290-3': 'Product Overview',
  'components.bottom-right.424290-4': 'Device Distribution',
  'components.rightContainer.712911-0': 'Basic Information',
  'components.rightContainer.712911-1': 'Device IMEI:',
  'components.rightContainer.712911-2': 'Device SN:',
  'components.rightContainer.712911-3': 'Product Type:',
  'components.rightContainer.712911-4': 'Heating & Cooling Heat Pump',
  'components.rightContainer.712911-5': 'Device Model:',
  'components.rightContainer.712911-6': 'Love2Plus/030MR1PN1A1/R',
  'components.rightContainer.712911-7': 'User Name:',
  'components.rightContainer.712911-8': 'Demo-Tom',
  'components.rightContainer.712911-9': 'User Phone:',
  'components.rightContainer.712911-10': 'Distributor:',
  'components.rightContainer.712911-11': 'Demo-Distributor',
  'components.rightContainer.712911-12': 'Installer:',
  'components.rightContainer.712911-13': 'Demo-Installer',
  'components.rightContainer.712911-14': 'Device Location:',
  'components.rightContainer.712911-15':
    'No. 73, Defu Road, Xingtan Town, Shunde District, Foshan City, Guangdong Province',
  'components.rightContainer.712911-16': 'House heating heat pump',
  'components.rightContainer.712911-17': 'Commercial heat pump series',
  'components.rightContainer.712911-18': 'Domestic hot water heat pump',
  'components.leftContainer.532259-0': 'Control Panel',
  'components.leftContainer.532259-1': 'Run Mode',
  'components.leftContainer.532259-2': 'Other Command',
  'components.leftContainer.532259-3': 'Cooling',
  'components.leftContainer.532259-4': 'Heating',
  'components.leftContainer.532259-5': 'DHW',
  'components.leftContainer.532259-6': 'FloorHeating',
  'components.leftContainer.532259-7': 'Standard Mode',
  'components.leftContainer.532259-8': 'Stronger Mode',
  'components.leftContainer.532259-9': 'Slient Mode',
  'components.leftContainer.532259-10': 'Cur.Temp',
  'components.middleContainer.912640-0': 'DHW Tank',
  'components.middleContainer.912640-1': 'Buffer Tank',
  'components.middleContainer.912640-2': 'Tank',
  'components.middleContainer.912640-3': 'Outlet',
  'components.middleContainer.912640-4': 'Intlet',
  zh: 'China',
  en: 'English',
  'components.bottom - right.424290-1': 'persons',
  'components.bottom - right.424290-2': 'family',
  山东: 'ShanDong',
  河北: 'HeBei',
  辽宁: 'LiaoNing',
  河南: 'HeNan',
  陕西: 'ShǎnXi',
  甘肃: 'GanSu',
  山西: 'ShānXi',
  内蒙古: 'NeiMeng',
  两联供: 'Heating & Cooling Unit',
  三联供: 'Heating&Cooling&Hot Water Unit',
  变频热水: 'Inverter Hot Water Unit',
  商用定频: 'Commercial On/off Unit',
  商用定频冷暖: 'Heating&Cooling&Hot Water Unit',
  商用定频热水: 'Commercial Hot Water Unit',
  loading: 'loading...',
  "utils.request.469615-0": "Data is being processed. Do not resubmit.",
  "utils.request.469615-1": "The login status has expired. You can either remain on this page or log in again.",
  "utils.request.469615-2": "System Prompt",
  "utils.request.469615-3": "Log in again",
  "utils.request.469615-4": "Cancel",
  "utils.request.469615-5": "Invalid session or the session has expired. Please log in again.",
  "utils.request.469615-6": "Abnormal connection of the backend interface",
  "utils.request.469615-7": "The system interface request timed out",
  "utils.request.469615-8": "System Interface",
  "utils.request.469615-9": "Abnormal",
  "utils.request.469615-10": "Data is being downloaded. Please wait.",
  "utils.request.469615-11": "An error occurred while downloading the file. Please contact the administrator!",
  "utils.request.401": "Authentication failed, unable to access system resources",
  "utils.request.403": "The current operation is not authorized",
  "utils.request.404": "The accessed resource does not exist",
  "utils.request.default": "Unknown system error, please report to the administrator",
  "bigScreen2025.250918.01": "Energy Flow",
  "bigScreen2025.250918.02": "Solar",
  "bigScreen2025.250918.03": "Heat Pump",
  "bigScreen2025.250918.04": "Grid",
  "bigScreen2025.250918.05": "Power Ratio",
  "bigScreen2025.250918.06": "Solar Power",
  "bigScreen2025.250918.07": "Grid Power",
  "bigScreen2025.250918.08": "Solar Ratio",
  "bigScreen2025.250918.09": "Energy Data",
  "bigScreen2025.250918.10": "Today’s Consumption",
  "bigScreen2025.250918.11": "Today’s PV Generation",
  "bigScreen2025.250918.12": "Today’s Grid Purchase",
  "bigScreen2025.250918.13": "Total Consumption",
  "bigScreen2025.250918.14": "Total PV Generation",
  "bigScreen2025.250918.15": "Total Grid Purchase",
  "bigScreen2025.250918.16": "Real-time Power Curve",
  "bigScreen2025.250918.17": "Energy Statistics",
  "bigScreen2025.250918.18": "Total",
  "bigScreen2025.250918.19": "Solar Supply",
  "bigScreen2025.250918.20": "Grid Supply",
  "bigScreen2025.250918.21": "Solar Supply Energy",
  "bigScreen2025.250918.22": "Grid Supply Energy",
  "bigScreen2025.250918.23": "Electricity Cost Statistics",
  "bigScreen2025.250918.24": "Solar Electricity Savings",
  "bigScreen2025.250918.25": "Grid Electricity Cost",
  "bigScreen2025.250918.26": "Control Panel",
  "bigScreen2025.250918.27": "Online",
  "bigScreen2025.250918.28": "Offline",
  "bigScreen2025.250918.29": "OFF",
  "bigScreen2025.250918.30": "ON",
  "bigScreen2025.250918.31": "Run Mode",
  "bigScreen2025.250918.32": "Standard",
  "bigScreen2025.250918.33": "Boost",
  "bigScreen2025.250918.34": "ECO",
  "bigScreen2025.250918.35": "Electric Heater",
  "bigScreen2025.250918.36": "Today",
  "bigScreen2025.250918.37": "Week",
  "bigScreen2025.250918.38": "Month",
  "bigScreen2025.250918.39": "Year",
  "bigScreen2025.250918.40": "All",
  "bigScreen2025.250918.41": "Device MAC",
  "bigScreen2025.250918.42": "Ele",
  "bigScreen2025.250918.43": "Heat",
  "bigScreen2025.250918.44": "Cool",
  "bigScreen2025.250918.45": "Auto",
  "bigScreen2025.250918.46": "Silent",
  "bigScreen2025.250918.47": "Realinks-IOT",
  "bigScreen2025.250918.48": "Heat Pump Demo",
  "bigScreen2025.250918.49": "Welcome back!",
  "bigScreen2025.250918.50": "Please enter your details to log in.",
  "bigScreen2025.250918.51": "Account",
  "bigScreen2025.250918.52": "Password",
  "bigScreen2025.250918.53": "Remember Password",
  "bigScreen2025.250918.54": "Sign in",
  "bigScreen2025.250918.55": "Lot Out",
  "bigScreen2025.250918.56": "PV Water Heater Demo (2nd Floor)",
  "bigScreen2025.250918.57": "Foshan, Guangdong Province, China",
  "bigScreen2025.250918.58": "PV Energy Ratio",
  "bigScreen2025.250918.59": "Total Consumption",
  "bigScreen2025.250918.60": "Total PV Generation",
  "bigScreen2025.250918.61": "Total Grid Import",
  "bigScreen2025.250918.62": "Open Object",
  "bigScreen2025.250918.63": "Please enter your account",
  "bigScreen2025.250918.64": "Please enter your password",
  "bigScreen2025.250918.65": "HeatPump Supply Energy",
  "bigScreen2025.250918.66": "Set Timer",
  "bigScreen2025.250918.67": "Start Time",
  "bigScreen2025.250918.68": "Repeat",
  "bigScreen2025.250918.69": "Run Mode",
  "bigScreen2025.250918.70": "Standard",
  "bigScreen2025.250918.71": "Visitor",
  "bigScreen2025.250918.72": "Sorry, guest mode has no permission to issue commands.",
  "bigScreen2025.250918.73": "Warning",
  "bigScreen2025.250918.74": "Solar Power",
  "bigScreen2025.250918.75": "Grid Power",
  "bigScreen2025.250918.76": "Heat Pump Power",
  "bigScreen2025.250918.77": "Current.Temp",
  "bigScreen2025.250918.79": "Cancel",
  "bigScreen2025.250918.78": "Confirm",
  "bigScreen2025.250918.80": "noData",
  "bigScreen2025.250918.81": "Day",
  "bigScreen2025.250918.82": "Week",
  "bigScreen2025.250918.83": "Month",
  "bigScreen2025.250918.84": "Year",
  "bigScreen2025.250918.85": "All",
  "bigScreen2025.250918.86": "Electricity Cost",
  "bigScreen2025.250918.87": "System Status",
  "bigScreen2025.250918.88": "Heat Pump",
  "bigScreen2025.250918.89": "Filter Valve",
  "bigScreen2025.250918.90": "Circulation pump",
  "bigScreen2025.250918.91": "Filter",
  "bigScreen2025.250918.92": "ON",
  "bigScreen2025.250918.93": "OFF",
  "bigScreen2025.250918.94": "Last Updated",
  "bigScreen2025.250918.95": "Pool Filtration and Temperature Control System",
  "bigScreen2025.250918.96": "Status",
  "bigScreen2025.250918.97": "Day",
  "bigScreen2025.250918.98": "Hour",
  "bigScreen2025.250918.99": "Min",
  "bigScreen2025.250918.100": "Sec",
  "bigScreen2025.250918.101": "Filtration Remaining Time",
  "bigScreen2025.250918.102": "FILTER",
  "bigScreen2025.250918.103": "Backwash Remaining Time",
  "bigScreen2025.250918.104": "BACKWASH",
  "bigScreen2025.250918.105": "Rinse Remaining Time",
  "bigScreen2025.250918.106": "RINSE",
  "bigScreen2025.250918.107": "WASTE",
  "bigScreen2025.250918.108": "RECIRC",
  "bigScreen2025.250918.109": "SWITCHING",
  "bigScreen2025.250918.110": "MORE",
  "bigScreen2025.250918.111": "MANUAL",
  "bigScreen2025.250918.112": "Modify Serial Number",
  "bigScreen2025.250918.113": "Enter serial number",
  "bigScreen2025.250918.114": "More Functions",
  "bigScreen2025.250918.115": "Filter Duration",
  "bigScreen2025.250918.116": "Rinse Start Time",
  "bigScreen2025.250918.117": "Wash Duration",
  "bigScreen2025.250918.118": "Backwash Duration",
  "bigScreen2025.250918.119": "Rinse Cycles",
  "bigScreen2025.250918.120": "grid",
  "bigScreen2025.250918.121": "solar",
  "bigScreen2025.250918.122": "Swimming Pool",
  "bigScreen2025.250918.123": "Electric Meter",
  "bigScreen2025.250918.124": "Control Panel",
  "bigScreen2025.250918.125": "Pool Drain Outlet",
  "bigScreen2025.250918.126": "Salt Chlorinator",
  "bigScreen2025.250918.127": "Pool Heat Pump",
  "bigScreen2025.250918.128": "Sand Filter",
  "bigScreen2025.250918.129": "Circulation Pump",
  "bigScreen2025.250918.130": "Swimming Pool Filter Valve",
  "bigScreen2025.250918.131": "From Pool",
  "bigScreen2025.250918.132": "Return To Pool",
  "bigScreen2025.250918.133": "Account or password incorrect！",
  "bigScreen2025.250918.134": "Analysis Report of Photovoltaic Direct-Driven Pool Heat Pump Operation Data",
  "bigScreen2025.250918.135": "Unit Type",
  "bigScreen2025.250918.136": "Unit Input Power",
  "bigScreen2025.250918.137": "Unit PV Configuration",
  "bigScreen2025.250918.138": "Pool Water Volume",
  "bigScreen2025.250918.139": "Sunrise Time",
  "bigScreen2025.250918.140": "Sunset Time",
  "bigScreen2025.250918.141": "Energy from PV",
  "bigScreen2025.250918.142": "Energy from Grid",
  "bigScreen2025.250918.143": "Unit Power Consumption",
  "bigScreen2025.250918.144": "PV Usage Share",
  "bigScreen2025.250918.145": "Grid Usage Share",
  "bigScreen2025.250918.146": "Grid Electricity Purchase Cost",
  "bigScreen2025.250918.147": "PV Savings Cost",
  "bigScreen2025.250918.148": "Unit Energy Consumption Statistics",
  "bigScreen2025.250918.149": "Unit Load Profile Analysis",
  "bigScreen2025.250918.150": "Download Screenshot",
  "bigScreen2025.250918.151": "Export Data",
  "bigScreen2025.250918.152": "Energy from PV",
  "bigScreen2025.250918.153": "Grid Power Consumption",
  "bigScreen2025.250918.154": "Unit Power Consumption",
  "bigScreen2025.250918.155": "Electricity Cost Classification Statistics",
  "bigScreen2025.250918.156": "Equivalent Electricity Cost Comparison of Pure Grid Heat Pump",
  "bigScreen2025.250918.157": "PV Cost Savings",
  "bigScreen2025.250918.158": "Grid Purchase Cost",
  "bigScreen2025.250918.159": "PV Savings Ratio",
  "bigScreen2025.250918.160": "Unit Energy Consumption Statistics",
  "bigScreen2025.250918.161": "Total Heating Energy Consumption",
  "bigScreen2025.250918.162": "Cumulative Heating Power Consumption",
  "bigScreen2025.250918.163": "Total Cooling Energy Consumption",
  "bigScreen2025.250918.164": "Total Heating Run Time",
  "bigScreen2025.250918.165": "Total Cooling Run Time",
  "bigScreen2025.250918.166": "Heating Power Consumption Ratio",
  "bigScreen2025.250918.167": "Cooling Power Consumption Ratio",
  "bigScreen2025.250918.168": "Unit Average Power Consumption",
  "bigScreen2025.250918.169": "Heating Average Power Consumption",
  "bigScreen2025.250918.170": "Cooling Average Power Consumption",
  "bigScreen2025.250918.171": "Heating Power Consumption",
  "bigScreen2025.250918.172": "Cooling Power Consumption",
  "bigScreen2025.250918.173": "Unit Run Time Classification Statistics",
  "bigScreen2025.250918.174": "Heating Run Time",
  "bigScreen2025.250918.175": "Cooling Run Time",
  "bigScreen2025.250918.176": "Standby Time",
  "bigScreen2025.250918.177": "Unit Operating Condition Analysis Statistics",
  "bigScreen2025.250918.178": "Unit Run/Stop Distribution Statistics",
  "bigScreen2025.250918.179": "Start",
  "bigScreen2025.250918.180": "Stop",
  "bigScreen2025.250918.181": "Unit Operation Power Consumption Distribution Statistics",
  "bigScreen2025.250918.182": "Operating Condition",
  "bigScreen2025.250918.183": "Energy Center",
  "bigScreen2025.250918.184": "Time",
  "bigScreen2025.250918.185": "Power",
  "bigScreen2025.250918.186": "All Day Start",
  "bigScreen2025.250918.187": "All Day Stop",
  "bigScreen2025.250918.188": "Counts",
  "bigScreen2025.250918.189": "PV Direct-Drive Pool Heat Pump",
  "bigScreen2025.250918.190": "Unit Energy Consumption Structure Statistics",
  "bigScreen2025.250918.191": "Days",
};
